/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable no-unused-vars */
import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { InfoClienteService } from 'app/consulta-mark-list/service/BehaviorSubject/infoClient.service';
import { ValidatorPerson } from 'app/consulta-mark-list/service/Validators/validator-person.service';
import { ConsultaMarkListService } from 'app/consulta-mark-list/service/consulta-mark-list.service';

import { AuthService, AvlaRestClientService } from 'base-angular-avla';
import { GenericTableAvlaService } from 'generic_table_avla_front_components/components/generic-table-avla/generic-tabla-avla.service';
import {
  ColumnMetadata,
  GenericTableAvlaComponent,
  PipeTransformMetadata,
} from 'generic_table_avla_front_components/components/generic-table-avla/generic-table-avla.component';
import {
  AvlaGenericComponent,
  MessageService,
  UiDatepickerDirective,
} from 'shared-angular-components-avla';

@Component({
  selector: 'app-ml-table-sinester',
  templateUrl: './ml-table-sinester.component.html',
  styleUrls: ['./ml-table-sinester.component.css'],
  providers: [DatePipe, UiDatepickerDirective],
})
export class MlTableSinesterComponent
  extends AvlaGenericComponent
  implements OnInit
{
  @Input() sinesterData: any[] = [];
  @ViewChild('tablaregistro') tablaregistros: GenericTableAvlaComponent;
  registrocolumnas: ColumnMetadata[];
  primaryIndexerTableSinester: string[] = ['id'];
  opcionincidencia: any = [];
  dataRegister: any = [];
  opcionesprocedencia = [
    { id: '1', name: 'Garantias Tecnicas' },
    { id: '2', name: 'Garantias Finacieras' },
    { id: '3', name: 'Seguros de Credito' },
  ];

  constructor(
    protected validatorPersonService: ValidatorPerson,
    protected restClientService: AvlaRestClientService,
    protected messageService: MessageService,
    protected router: Router,
    protected authService: AuthService,
    protected datePipe: DatePipe,
    protected marklistservice: ConsultaMarkListService,
    protected genericTableAvlaService: GenericTableAvlaService,
    protected infoClientSubjectService: InfoClienteService
  ) {
    super(restClientService, messageService, router, authService);

    this.registrocolumnas = [
      new ColumnMetadata(
        'Fecha de siniestro',
        'sinisterDate',
        '',
        false,
        false,
        [new PipeTransformMetadata(datePipe, ['dd/MM/yyyy'])],
        false,
        true,
        0
      ),
      new ColumnMetadata(
        'Indicador',
        'indicator',
        '',
        false,
        false,
        null,
        false,
        true,
        1
      ),
      new ColumnMetadata(
        'Procedencia',
        { colName: 'procedencia', keyData: 'idBusiness' },
        '',
        false,
        false,
        null,
        false,
        true,
        2
      ),
      new ColumnMetadata(
        'Tipo incidente',
        { colName: 'incidencia', keyData: 'idTypeIncidence' },
        '',
        false,
        false,
        null,
        false,
        true,
        3
      ),
      new ColumnMetadata(
        'Observación',
        'observation',
        '',
        false,
        false,
        null,
        false,
        true,
        4
      ),
    ];
  }

  ngOnInit(): void {
    this.getopcionincidencia();
  }

  getopcionincidencia() {
    this.marklistservice.getIncidenceList().subscribe(
      data => {
        if (this.errorInResponse(data)) {
          return;
        }
        this.opcionincidencia = data;
      },
      error => {
        this.routeAccordingError(error);
      }
    );
  }

  getprocedencia(id) {
    const procedencia = this.opcionesprocedencia
      .filter(o => o.id === id.toString())
      .map(t => t.name);
    return procedencia[0] ? procedencia[0] : null;
  }

  getincidencia(id) {
    const incidencia = this.opcionincidencia
      .filter(o => o.idTypeIncidence === id)
      .map(t => t.nameTypeIncidence);
    return incidencia[0] ? incidencia[0] : null;
  }
}
